import { render, staticRenderFns } from "./SmartfeedProfileHistory3.vue?vue&type=template&id=07e5debb&scoped=true&"
import script from "./SmartfeedProfileHistory3.vue?vue&type=script&lang=js&"
export * from "./SmartfeedProfileHistory3.vue?vue&type=script&lang=js&"
import style0 from "./SmartfeedProfileHistory3.vue?vue&type=style&index=0&id=07e5debb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e5debb",
  null
  
)

export default component.exports